import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/apiClient";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <Layout>
      <section className="border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16">
          <div className="label-mono text-[#002FA7] mb-4">— Blog · Informazioni · FAQ</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mb-6">Guida al concorso EPSO AD5</h1>
          <p className="text-lg text-slate-600 max-w-2xl leading-relaxed">
            Approfondimenti aggiornati su date, struttura delle prove, piano di studio e prospettive di carriera del concorso EPSO/AD/427/26.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="blog-list">
          {posts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
              className="group border border-slate-200 bg-white p-8 flex flex-col hover:shadow-hard transition-all hover:-translate-y-1">
              <div className="label-mono text-xs bg-slate-100 text-slate-600 self-start px-2 py-1 mb-4">{p.categoria}</div>
              <h2 className="font-display font-bold text-xl mb-3 leading-snug">{p.title}</h2>
              <p className="text-sm text-slate-600 leading-relaxed flex-1">{p.meta_description}</p>
              <span className="mt-6 label-mono text-[#002FA7] flex items-center gap-2 group-hover:gap-3 transition-all">Leggi l'articolo <ArrowRight className="w-4 h-4" /></span>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
}
